import { AttributeListRowModel } from './attribute-list-row.model';
import { AttributeListColumnModel } from './attribute-list-column.model';

export interface AttributeListDataModel {
  id: string;
  tabId: string;
  featureType?: string;
  columns: AttributeListColumnModel[];
  rows: AttributeListRowModel[];
  checkedRows: { id: string; __fid: string }[];
  selectedRowId?: string;
  pageSize: number;
  pageIndex: number;
  totalCount: number | null;
  sortedColumn?: string;
  sortDirection: 'asc' | 'desc' | '';
  errorMessage?: string;
}

